import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import Adresse from "../components/address";
import { Row, ColumnTow } from "../components/FooterStyles";
import { API_URL } from "../constant";

import "../styles/home.scss";

const Categories = () => {
  const { id } = useParams();
  const history = useHistory();
  const [prestataires, setPrestataires] = useState(
    (history.location &&
      history.location.state &&
      history.location.state.data) ||
      []
  );
  const [loading, setLoading] = useState(false);
  const [city, setCity] = useState("chez vous");
  const [hideDe, setHideDe] = useState(false);

  const getCatById = () => {
    switch (id) {
      case "coiffure":
        return "Coiffure";
      case "barber":
        return "Barber";
      case "onglerie":
        return "Onglerie";
      case "beaute":
        return "Institut de beauté";
      case "bien-etre":
        return "Bien être";
      case "search":
        return (
          history &&
          history.location &&
          history.location.state &&
          history.location.state.title
        );
      default:
        break;
    }
  };

  const getCatByIdWeb = () => {
    switch (id) {
      case "coiffure":
        return "COIFFURE";
      case "barber":
        return "BARBER";
      case "onglerie":
        return "ONGLERIE";
      case "beaute":
        return "INSTITUT DE BEAUTE";
      case "bien-etre":
        return "BIEN ÊTRE";

      default:
        break;
    }
  };

  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  useEffect(() => {
    if (
      window.innerWidth > 800 //||
      // window.innerWidth == 1080 ||
      // window.innerWidth == 760
    ) {
      const handleResize = () => {
        console.log("window.innerWidth", window.innerWidth);
        setSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      };
      window.addEventListener("resize", handleResize);

      return () => window.removeEventListener("resize", handleResize);
    }
  }, [size]);

  function getProbycat() {
    setLoading(true);
    fetch(API_URL + "prosbycat", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        cat: getCatByIdWeb(),
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.success) {
          // alert(JSON.stringify(data.data));
          setPrestataires(data.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.watchPosition(function (position) {
        // console.log("Latitude is :", position.coords.latitude);
        // console.log("Longitude is :", position.coords.longitude);
        fetch(API_URL + "zipcode", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            lat: position.coords.latitude,
            long: position.coords.longitude,
          }),
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.city) {
              if (
                data.city == "du Port" ||
                data.city === "des Avirons" ||
                data.city === "du Tampon"
              ) {
                setHideDe(true);
              } else {
                setHideDe(false);
              }
              setCity(data.city);
            } else {
              setHideDe(false);
              setCity("chez vous");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    }
    if (id != "search") {
      getProbycat();
    }
  }, [id]);

  const Hero = () => {
    const [searchInProgress, setSearchLoading] = useState(false);
    const [prestation, setPrestation] = useState(getCatById());
    const [lieu, setLieu] = useState(
      history.location && history.location.state && history.location.state.where
    );
    const [dat, setD] = useState(
      history.location && history.location.state && history.location.state.date
    );

    const [time, setTime] = useState(
      (history.location &&
        history.location.state &&
        history.location.state.time) ||
        null
    );
    const makeSearch = (e) => {
      e.preventDefault();
      if (searchInProgress) {
        return;
      }
      setSearchLoading(true);
      // console.log("nom", e.target.nom.value);
      // console.log("ou", e.target.ou.value);
      // console.log("quand", e.target.quand.value);
      fetch(API_URL + "search", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          title: e.target.nom.value,
          where: e.target.ou.value,
          date: new Date(e.target.quand.value),
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          setSearchLoading(false);
          if (data.success) {
            if (data.data.length == 0) {
              setPrestataires([]);
              alert("Aucun résultat.");
            } else {
              // console.log(data);
              setPrestataires(data.data);
              history.push({
                pathname: "/categories/search",
                state: {
                  data: data.data,
                  title: e.target.nom.value,
                  where: e.target.ou.value,
                  date: e.target.quand.value,
                },
              });
            }
          } else {
            alert("Une erreur s'est produite lors de la recherche");
          }
        })
        .catch((err) => {
          setSearchLoading(false);
          console.log(err);
        });
    };

    return (
      <div
        className="composant-29-2"
        style={{
          height: 500,
          marginTop: -100,
          marginBottom: 42,
          // backgroundImage: `url('https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/62341339dacf5d485e5362f3/img/hero-banner-on-fleek@1x.png')`,
          // margin: "auto",

          // backgroundImage: "url(process.env.PUBLIC_URL + '/stock-photo-couple-of-fashionable-young-people-posing-outdoor-in.png')"
        }}
      >
        <div
          className="onglet-de-recherche"
          style={{
            height: size.width > 1380 ? 130 : size.width > 1100 ? 180 : 260,
          }}
        >
          <div className="barre-de-recherche">
            <form onSubmit={makeSearch}>
              <Row className="customSearch">
                <ColumnTow>
                  <div className="nom-du-salon-ou-de-la-prestation">
                    <input
                      className="nom-du-salon-prestations-couperaleway-normal-silver-14px"
                      name="nom"
                      placeholder="Nom du salon, prestations (coupe…)"
                      type="text"
                      value={prestation}
                      autocomplete="off"
                      style={{
                        paddingLeft: 0,
                        fontFamily: "Raleway!important",
                        maxWidth: size.width > 600 ? 220 : "80%",
                      }}
                      onChange={(e) => setPrestation(e.currentTarget.value)}
                    />
                    <div className="search">
                      <img
                        className="icon-awesome-search-alt"
                        src={process.env.PUBLIC_URL + "/trac-208-2.png"}
                        alt=""
                      />
                    </div>
                    <img
                      className="ligne-1"
                      src={process.env.PUBLIC_URL + "/ligne-1-14.png"}
                      alt=""
                    />
                  </div>
                </ColumnTow>
                <div className="lieu">
                  <img
                    className="icon-material-location-on"
                    src={
                      process.env.PUBLIC_URL +
                      "/icon-material-location-on-1.png"
                    }
                    alt=""
                  />
                  <input
                    className="oraleway-normal-silver-14px"
                    name="ou"
                    placeholder="Où ?"
                    value={lieu}
                    onChange={(e) => setLieu(e.currentTarget.value)}
                    style={{ fontFamily: "Raleway!important" }}
                  />

                  <img
                    className="ligne-2"
                    src={process.env.PUBLIC_URL + "/ligne-2-2.png"}
                    alt=""
                  />
                </div>
                <ColumnTow>
                  <div className="date">
                    {navigator.userAgent.includes("Safari") &&
                    !navigator.userAgent.includes("Android") &&
                    !navigator.userAgent.includes("Chrome") ? (
                      <img
                        className="icon-awesome-calendar-alt"
                        src={
                          process.env.PUBLIC_URL +
                          "/icon-awesome-calendar-alt-1.png"
                        }
                        alt=""
                      />
                    ) : (
                      <img
                        className="icon-awesome-calendar-alt"
                        style={{ position: "absolute" }}
                        src={
                          process.env.PUBLIC_URL +
                          "/icon-awesome-calendar-alt-1.png"
                        }
                        alt=""
                      />
                    )}
                    {navigator.userAgent.includes("Safari") &&
                    !navigator.userAgent.includes("Android") &&
                    !navigator.userAgent.includes("Chrome") ? (
                      <input
                        type={"datetime-local"}
                        className="quandraleway-normal-silver-14px"
                        name="quand"
                        value={dat}
                        onChange={(e) => setD(e.currentTarget.value)}
                        style={{
                          fontFamily: "Raleway!important",
                          marginLeft:
                            (size.width < 600 || size.width <= 1080) && 20,
                          position:
                            (size.width < 600 || size.width == 1080) &&
                            "relative",
                          top: (size.width < 600 || size.width == 1080) && -8,
                        }}
                      />
                    ) : (
                      <>
                        <div
                          style={{
                            display: "flex",
                            position: "relative",
                            top: 0,
                            marginLeft: 10,
                            background: "transparent",
                            height: 20,
                            left: 20,
                          }}
                        >
                          <input
                            type={"date"}
                            className="quandraleway-normal-silver-14px"
                            name="quand"
                            placeholder="Quand ? "
                            value={dat}
                            onChange={(e) => setD(e.currentTarget.value)}
                            style={{
                              paddingLeft: 0,
                              fontFamily: "Raleway!important",
                              color: "#aea9a9",
                            }}
                          />
                          <input
                            name="time"
                            className="quandraleway-normal-silver-14px"
                            type="time"
                            placeholder="l'heure ? "
                            value={time}
                            style={{
                              paddingLeft: 0,
                              background: "transparent",
                              fontFamily: "Raleway!important",
                              color: "#aea9a9",
                            }}
                          />
                        </div>
                      </>
                    )}
                    <img
                      className="ligne-2-1"
                      style={{
                        bottom: size.width == 1080 && 9,
                      }}
                      src={process.env.PUBLIC_URL + "/ligne-2-1.png"}
                      alt=""
                    />
                  </div>
                </ColumnTow>
                <ColumnTow>
                  {searchInProgress ? (
                    <div
                      style={{
                        margin: "auto",
                        width: 55,
                        position: "relative",
                        right: 20,
                      }}
                    >
                      <div class="loader" />
                    </div>
                  ) : (
                    <>
                      {size.width >= 1080 ? (
                        <>
                          <button
                            type="submit"
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                            }}
                          >
                            <div
                              className="bouton-recherche"
                              style={{
                                marginLeft: size.width == 1080 && -20,
                              }}
                            >
                              <div
                                className="search-1"
                                style={{
                                  backgroundImage: `url('/trac-208-1.png`,
                                }}
                              ></div>
                            </div>
                          </button>
                        </>
                      ) : (
                        <div
                        // style={{ width: size.width <= 428 && "calc(100% - 97px)" }}
                        >
                          <button
                            type="submit"
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                            }}
                          >
                            <div
                              class="bouton-plein"
                              style={{
                                height: size.width <= 1024 && "32px!important",
                              }}
                            >
                              <div class="rechercher">Rechercher</div>
                              <div class="search-2"></div>
                            </div>
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </ColumnTow>
              </Row>
            </form>
          </div>
        </div>
        <h1
          className="rservez-vos-rendez raleway-extra-bold-eerie-black-50px"
          style={{
            width:
              size.width > 1288
                ? "80%"
                : size.width > 800
                ? size.width * 0.9
                : "100%",
            color: "black", //size.width > 1200 || size.width < 800 ? "black" : "white",
            top:
              size.width > 1380
                ? 100
                : size.width > 1200
                ? 80
                : size.width > 414
                ? size.width >= 428
                  ? size.width == 810
                    ? 0
                    : -150
                  : -90
                : size.width > 320
                ? -70
                : -110,
            // textShadow:
            //   size.width > 1200 || size.width < 800
            //     ? "none"
            //     : "0px 3px 15px black",
            maxWidth:
              size.width > 1200
                ? 1920
                : size.width > 800
                ? size.width * 0.8
                : "100%",
            fontSize: size.width <= 360 ? 32 : size.width < 415 && 35,
          }}
        >
          Les meilleurs prestataires aux
          {size.width !== 810 && <br />}
          {" alentours"} {!hideDe && "de "} {city}
        </h1>
      </div>
    );
  };

  const BlocRDV = ({ data }) => {
    const [ensavoirplus, setEnsavoirPlus] = useState(false);
    const [horaire, setHoraires] = useState(null);

    useEffect(() => {
      if (ensavoirplus && horaire == null) loadHoraire();
    }, [ensavoirplus]);

    function loadHoraire() {
      fetch(API_URL + "horaire", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: data.id,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            // alert(JSON.stringify(data.data));
            setHoraires(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }

    const openRDV = () => {
      let res = data;
      res.horaire = horaire;
      history.push({ pathname: "/p/" + data.id, state: res });
    };

    return (
      <div className="col-75 bloc-rdv" style={{ padding: 0, marginBottom: 60 }}>
        <div className="content-sha content-rdv" style={{ borderRadius: 30 }}>
          <div
            style={{
              justifyContent: "left",
              display: size.width > 428 ? "flex" : "inherit",
              alignItems: "flex-start",
            }}
          >
            <div
              className="img-test-2"
              style={{
                height: "300px!important",
                cursor: "pointer",
                backgroundImage:
                  data.pictures &&
                  data.pictures[0] &&
                  `url("` + data.pictures[0] + `")`,
              }}
              onClick={openRDV}
            />
            <div style={{ width: "100%", padding: 0 }} className="col-50">
              <div
                className="sub-content-rdv"
                style={{ marginLeft: size.width > 428 && 87 }}
              >
                <div
                  class="vous-avez-dj-un-compte raleway-bold-eerie-black-20px"
                  style={{
                    marginBottom: size.width > 428 && 15,
                    marginTop: size.width > 428 ? 47 : 23,
                    marginLeft: size.width <= 428 && 15,
                    cursor: "pointer",
                    position: "relative",
                    width: size.width >= 810 && "128%",
                  }}
                  onClick={openRDV}
                >
                  {data.name}
                </div>
                <div
                  style={{
                    paddingLeft: size.width <= 428 && 16,
                  }}
                >
                  <Adresse
                    address={
                      data.adresse + " " + data.zipcode + " " + data.city
                    }
                  />
                </div>

                <div
                  style={{
                    paddingBottom: size.width > 428 && 5,
                    paddingLeft: size.width <= 428 && 15,
                  }}
                ></div>
              </div>
            </div>
            {data.holidayMode || !data.isActif ? (
              <div
                style={{
                  height: 50,
                  borderRadius: 15,
                  color: "white",
                  marginRight: 30,
                  marginLeft: size.width <= 428 && 30,
                  marginTop: size.width > 428 && 190,
                }}
              >
                <Adresse
                  address={
                    "Le prestataire est actuellement " +
                    (!data.isActif ? "indisponible." : "en vacance.")
                  }
                />
              </div>
            ) : (
              <input
                onClick={openRDV}
                type="submit"
                class="bouton-plein border-1px-dove-gray sinscrire raleway-bold-eerie-black-14px btn"
                style={{
                  height: 50,
                  borderRadius: 15,
                  color: "white",
                  border: "none",
                  marginRight: 30,
                  marginLeft: size.width <= 428 && 30,
                  marginTop: size.width > 428 && 190,
                }}
                value="Prendre RDV"
              />
            )}
          </div>
          {size.width > 428 && <div className="divider" />}
          <div
            style={{
              padding: ensavoirplus
                ? size.width > 600
                  ? "33px  0px 44px 111px"
                  : "33px  0px 44px 31px"
                : "33px  0px 44px 30px",
            }}
            className="raleway-bold-eerie-black-18px"
            onClick={() => {
              setEnsavoirPlus(!ensavoirplus);
            }}
          >
            <u>En savoir plus</u>
            {ensavoirplus && (
              <>
                <div style={{ marginTop: 20 }}>{/* <p>Adresse :</p> */}</div>
                <br />
                <u>Horaires :</u>
                <p
                  className={
                    size.width > 600
                      ? "raleway-medium-dove-gray-18px"
                      : "raleway-medium-dove-gray-14px"
                  }
                >
                  {horaire ? (
                    <>
                      <br />
                      {horaire.lun[0] && (
                        <>
                          Lundi : {horaire.lun[0]} - {horaire.lun[1]}
                          {horaire.lun[2] &&
                            " | " + horaire.lun[2] + " - " + horaire.lun[3]}
                          <br />
                          <br />
                        </>
                      )}
                      {horaire.mar[0] && (
                        <>
                          Mardi : {horaire.mar[0]} - {horaire.mar[1]}
                          {horaire.mar[2] &&
                            " | " + horaire.mar[2] + " - " + horaire.mar[3]}
                          <br />
                          <br />
                        </>
                      )}
                      {horaire.mer[0] && (
                        <>
                          Mercredi : {horaire.mer[0]} - {horaire.mer[1]}
                          {horaire.mer[2] &&
                            " | " + horaire.mer[2] + " - " + horaire.mer[3]}
                          <br />
                          <br />
                        </>
                      )}
                      {horaire.jeu[0] && (
                        <>
                          Jeudi : {horaire.jeu[0]} - {horaire.jeu[1]}
                          {horaire.jeu[2] &&
                            " | " + horaire.jeu[2] + " - " + horaire.jeu[3]}
                          <br />
                          <br />
                        </>
                      )}
                      {horaire.ven[0] && (
                        <>
                          Vendredi : {horaire.ven[0]} - {horaire.ven[1]}
                          {horaire.ven[2] &&
                            " | " + horaire.ven[2] + " - " + horaire.ven[3]}
                          <br />
                          <br />
                        </>
                      )}
                      {horaire.sam[0] && (
                        <>
                          Samedi : {horaire.sam[0]} - {horaire.sam[1]}
                          {horaire.sam[2] &&
                            " | " + horaire.sam[2] + " - " + horaire.sam[3]}
                          <br />
                          <br />
                        </>
                      )}
                      {horaire.dim[0] && (
                        <>
                          Dimanche : {horaire.dim[0]} - {horaire.dim[1]}
                          {horaire.dim[2] &&
                            " | " + horaire.dim[2] + " - " + horaire.dim[3]}
                        </>
                      )}
                    </>
                  ) : (
                    "Chargement..."
                  )}
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {/* <h1>{getCatById()}</h1> */}
      <Hero />
      <div
        class="row"
        style={{
          maxWidth:
            size.width > 428 && size.width != 810
              ? "76%"
              : size.width == 810 && "91%",
          margin: "0px auto",
        }}
      >
        <div
          class="col-75"
          style={{
            marginLeft: size.width <= 428 && 20,
            marginRight: size.width <= 428 && 20,
            padding: 0,
          }}
        >
          <div
            class="container"
            style={{ padding: size.width <= 428 && size.width > 360 ? 16 : 0 }}
          >
            {loading ? (
              <div style={{ margin: "auto", padding: "60px 0px", width: 55 }}>
                <div class="loader" />
              </div>
            ) : (
              <>
                {prestataires.length > 0 ? (
                  prestataires.map((e) => <BlocRDV data={e} />)
                ) : (
                  <p className="content-p " style={{ marginBottom: 100 }}>
                    Aucun résultat de recherche.
                  </p>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Categories;
